import { render } from "./v-tabs.vue?vue&type=template&id=7ad421d9&scoped=true"
import script from "./v-tabs.vue?vue&type=script&lang=js"
export * from "./v-tabs.vue?vue&type=script&lang=js"

import "./v-tabs.vue?vue&type=style&index=0&id=7ad421d9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad421d9"]])

export default __exports__